import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { AppCard, AppModal, AppNoInfo, AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import Translator from "../../../../layout/components/helpers/Translator";
import { axiosPath } from "../../../../routing/helpers/router";
import AppLink from "../../../../routing/helpers/AppLink";
import CommunicationPipelineUserNavbar from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserNavbar";
import colors from "../../../../constants/colors";
import useIsMounted from "../../../../layout/components/hooks/useIsMounted";
import CommunicationPipelineLogin from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineLogin";
import { useSelector } from "react-redux";
import errorHandler from "@/layout/components/error/ErrorHandler";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";
import * as currentPageAction from "../../../../store/actions/currentPageAction";

export default function CommunicationPipelineUserReportThreadScreen() {
  const { moduleBridgeHex, reportHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [userType] = useState("user");
  const [threads, setThreads] = useState();
  const [unseenCommunicationThreads, setUnseenCommunicationThreads] = useState(
    [],
  );
  const authReports = useSelector((state) => state.currentPage?.reports) || [];
  const [isAuth, setIsAuth] = useState(false);
  const moduleData = useSelector((state) => state.currentPage?.moduleData);

  const loadThreads = useCallback(async () => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_report_thread_list"),
        {
          moduleBridgeHex,
          reportHex,
          type: userType,
        },
      )
      .then((r) => {
        if (isMounted.current) {
          setThreads(r?.data?.threads);
          setUnseenCommunicationThreads(r?.data?.unseenCommunicationThreads);
        }
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [moduleBridgeHex, reportHex, userType]);

  useEffect(() => {
    if (reportHex && authReports.includes(reportHex)) {
      setIsAuth(true);
    }
  }, []);

  useEffect(() => {
    loadThreads();
  }, []);

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  if (!moduleData) return <AppNoInfo />;

  if (isAuth === false) {
    return (
      <>
        {moduleData?.permissionLevel === 0 && (
          <CommunicationPipelineModuleSidebar />
        )}
        <AppModal show={isAuth === false} isCloseButton={false}>
          <CommunicationPipelineLogin onAuth={() => setIsAuth(true)} />
        </AppModal>
      </>
    );
  }

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <Container>
        <CommunicationPipelineUserNavbar />
        {threads &&
          threads.map((t) => (
            <LazyLoad key={t.hex}>
              <AppCard className="mb-2">
                <div className="d-flex align-center">
                  <AppLink
                    path="user_module_communicationPipeline_user_report_communication"
                    params={{
                      moduleBridgeHex,
                      reportHex,
                      threadHex: t.hex,
                    }}
                    className="wl-title-md wl-title-color"
                  >
                    <span className="badge badge-dark mr-2">
                      {t?.dateStamp}
                    </span>
                    <span className="font-weight-bold">{t?.name}</span>
                    {unseenCommunicationThreads?.includes(t?.hex) && (
                      <span className="ml-2">
                        <AppRemixIcon
                          icon="notification"
                          color={colors.bootstrapWarning}
                          filled
                        />
                      </span>
                    )}
                  </AppLink>
                </div>
              </AppCard>
            </LazyLoad>
          ))}
        {threads !== undefined && threads.length === 0 && (
          <AppCard>
            <Translator
              file="module-communicationPipeline"
              name="there-no-communication-threads"
            />
          </AppCard>
        )}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
`;
